import { Link } from '@tanstack/router'
import { useTranslation } from 'react-i18next'

import { useBoundStore } from '../../store/store'
import classNames from '../../utils/classNames'
import Icon from '../icon'

const FooterLinks = () => {
  const { t, i18n } = useTranslation(['drawer', 'footer'])
  const { language } = i18n
  const pending_bind = useBoundStore(state => state.user.pending_bind)
  const setIsChatVisible = useBoundStore(state => state.common.setIsChatVisible)
  const setIsPendingDepositVisible = useBoundStore(
    state => state.common.setIsPendingDepositVisible,
  )
  const blogUrl = useBoundStore(state => state.settings.footer_blog.value)

  return (
    <div className="grid grid-cols-[1fr_1fr] gap-5 mb-5 px-5 py-0 xl:w-[1200px] xl:flex xl:justify-between xl:grid-cols-4 xl:mt-[60px] xl:mb-5 2xl:p-0">
      <div
        className={classNames(
          '[&>a]:block [&>a]:text-txt [&>a]:leading-[50px] [&>a]:text-sm [&>a]:text-left [&>a]:mx-0 [&>a]:-my-2.5 [&>a]:transition-all',
          '[&>a]:duration-[0.2s] [&>a]:ease-[ease-in-out] [&>a]:hover:opacity-70 [&>a]:xl:text-base [&>a]:xl:mb-2.5',
        )}>
        <p className="uppercase block text-txt font-Geometr706-BlkCn-BT leading-[50px] text-[15px] text-left mx-0 -my-2.5 xl:text-lg xl:mb-3">
          {t('information', { ns: 'footer' })}
        </p>
        <Link to="/footer/$page" params={{ page: 'we' }}>
          {t('about-us', { ns: 'footer' })}
        </Link>
        <Link
          to="/footer/$page"
          params={{
            page:
              language === 'en'
                ? 'terms-and-conditions'
                : 'terminos-y-condiciones',
          }}>
          {t('terms-and-conditions', { ns: 'footer' })}
        </Link>
        <Link to="/footer/$page" params={{ page: 'responsible-gaming' }}>
          {t('responsible-gaming', { ns: 'footer' })}
        </Link>
        <Link
          to="/footer/$page"
          params={{ page: 'privacy-notice-and-site-cookies' }}>
          {t('privacy-notice-and-site-cookies', { ns: 'footer' })}
        </Link>
        <Link to="/footer/$page" params={{ page: 'affiliate-program' }}>
          {t('affiliate-program', { ns: 'footer' })}
        </Link>
        <Link to="/footer/$page" params={{ page: 'betting-mechanics' }}>
          {t('betting-mechanics', { ns: 'footer' })}
        </Link>
        <Link to="/footer/$page" params={{ page: 'betting-conditions' }}>
          {t('betting-conditions', { ns: 'footer' })}
        </Link>
      </div>
      <div
        className={classNames(
          '[&>a]:block [&>a]:text-txt [&>a]:leading-[50px] [&>a]:text-sm [&>a]:text-left [&>a]:mx-0 [&>a]:-my-2.5 [&>a]:transition-all',
          '[&>a]:duration-[0.2s] [&>a]:ease-[ease-in-out] [&>a]:hover:opacity-70 [&>a]:xl:text-base [&>a]:xl:mb-2.5',
        )}>
        <p className="uppercase block text-txt font-Geometr706-BlkCn-BT leading-[50px] text-[15px] text-left mx-0 -my-2.5 xl:text-lg xl:mb-3">
          {t('our-sections', { ns: 'footer' })}
        </p>
        <Link
          to={
            +pending_bind === 0 || +pending_bind === 2 ? undefined : '/sports'
          }
          onClick={() => {
            if (+pending_bind === 0 || +pending_bind === 2)
              setIsPendingDepositVisible(true)
          }}>
          {t('sports', { ns: 'drawer' })}
        </Link>
        <Link to="/casino/$category" params={{ category: 'lobby' }}>
          {t('casino', { ns: 'drawer' })}
        </Link>
        <Link to="/promotions">{t('promotions', { ns: 'footer' })}</Link>
        <a href={blogUrl} target="_blank" rel="noreferrer">
          {t('blog', { ns: 'footer' })}
        </a>
        <Link to="/footer/$page" params={{ page: 'mexplay_tutorials' }}>
          {t('tutorials', { ns: 'footer' })}
        </Link>
      </div>
      <div
        className={classNames(
          '[&>a]:block [&>a]:text-txt [&>a]:leading-[50px] [&>a]:text-sm [&>a]:text-left [&>a]:mx-0 [&>a]:-my-2.5 [&>a]:transition-all',
          '[&>a]:duration-[0.2s] [&>a]:ease-[ease-in-out] [&>a]:hover:opacity-70 [&>a]:xl:text-base [&>a]:xl:mb-2.5',
        )}>
        <p className="uppercase block text-txt font-Geometr706-BlkCn-BT leading-[50px] text-[15px] text-left mx-0 -my-2.5 xl:text-lg xl:mb-3">
          {t('help', { ns: 'footer' })}
        </p>
        <Link to="/footer/$page" params={{ page: 'faq' }}>
          {t('faqs', { ns: 'footer' })}
        </Link>
        <Link to="/footer/$page" params={{ page: 'deposit' }}>
          {t('deposit', { ns: 'footer' })}
        </Link>
        <Link to="/footer/$page" params={{ page: 'withdraw' }}>
          {t('withdraw', { ns: 'footer' })}
        </Link>
        <Link to="/footer/$page" params={{ page: 'refund-policy' }}>
          {t('refund-policy', { ns: 'footer' })}
        </Link>
      </div>
      <div>
        <p className="uppercase block text-txt font-Geometr706-BlkCn-BT leading-[50px] text-[15px] text-left mx-0 -my-2.5 xl:text-lg xl:mb-3">
          {t('contact-us', { ns: 'footer' })}
        </p>
        <button
          className={classNames(
            'block text-txt leading-[50px] cursor-pointer text-sm text-left mx-0 -my-2.5',
            'transition-all duration-[0.2s] ease-[ease-in-out] hover:opacity-70 xl:text-base xl:mb-2.5',
          )}
          onClick={() => setIsChatVisible(true)}>
          {t('online-chat', { ns: 'footer' })}
        </button>
        {/* <a href="mailto:info@mexplay.mx" target="_blank" rel="noreferrer">
          {t('email')}: info@mexplay.mx
        </a>
        <p>{t('phone')}: +52 553 398 16 92</p> */}
        <div className="flx-str-ctr gap-3 mt-2 xl:mt-3.5 [&_svg]:fill-txt [&>a]:flex [&>a]:items-center [&>a]:justify-center [&>a]:h-12 [&>a]:m-0">
          <a
            aria-label="instagram page"
            href="https://www.instagram.com/mexplay.mx/"
            target="blank">
            <Icon id="instagram" width="36" height="36" />
          </a>
          <a
            aria-label="twitter page"
            href="https://twitter.com/mexplay_mx"
            target="blank">
            <Icon id="twitter" width="39" height="42" />
          </a>
          <a
            aria-label="facebook-page"
            href="https://www.facebook.com/mexplay.mx"
            target="blank">
            <Icon id="facebook-f" width="20" height="36" />
          </a>
          <div>
            <Icon id="18-plus" width="38" height="38" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FooterLinks
